import React from "react";
import moment from "moment";

export const WeekNumber = ({ date }: { date: string | undefined | null }) => {
  if (!date) return null;

  return <>{moment(date).isoWeek()}</>;
};
